// ABOUTME: "My reports" account tab listing the caller's own feedback with derived status only.
// ABOUTME: Internal triage status is never shown; the backend supplies a derived status key (received/in_progress/resolved).

import { Box, useTheme } from "@mui/material";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { tokens } from "../../../../theme";
import Subheading from "../../../../components/theme/text/Subheading";
import Text from "../../../../components/theme/text/Text";
import { useGetMyReportsQuery } from "../../../../newapi/feedback/feedbackApiSlice";

const MyReports = (props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const { data: reports = [] } = useGetMyReportsQuery();

    useEffect(() => {
        props.replaceView({ ...props.config });
        return () => {};
    }, []);

    return (
        <Box sx={{ p: 3, display: "flex", flexDirection: "column", gap: 2 }}>
            <Subheading>{t("feedback_my_reports_title")}</Subheading>
            {reports.length === 0 && <Text light>{t("feedback_my_reports_empty")}</Text>}
            {reports.map((r) => (
                <Box
                    key={r.referenceId}
                    sx={{
                        p: 2,
                        borderRadius: 2,
                        background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                        display: "flex",
                        flexDirection: "column",
                        gap: 0.5,
                    }}
                >
                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                        <Text bold>{r.referenceId}</Text>
                        <Text light>{t(`feedback_status_${r.status || "received"}`)}</Text>
                    </Box>
                    <Text light>{t(`feedback_category_${String(r.category).toLowerCase()}`)}</Text>
                    <Text>{r.narrative}</Text>
                </Box>
            ))}
        </Box>
    );
};

export default MyReports;
